import { Box, Button, makeStyles } from "@material-ui/core";
import { QuoteLineItem } from "../../../api/Quote/QuoteLineItem";
import DoneIcon from "@material-ui/icons/Done";
import { colors } from "swyft-react-core";

const QuoteButtonAdd = ({ addon, onAddAddon, disabled = false, ...rest }: Props) => {
  const classes = useStyles();

  const onAdd = async function () {
    if (onAddAddon) {
      await onAddAddon(addon);
    }
  };

  return (
    <Button
      {...rest}
      onClick={onAdd}
      variant="contained"
      color={addon.selected ? "default" : "secondary"}
      className={addon.selected ? classes.buttonAdded : classes.button}
      disabled={disabled}
    >
      <Box pr={addon.selected ? 1 : 0} component="span" alignItems="center">
        {addon.selected && <DoneIcon className={classes.icon} fontSize="small" />}
      </Box>
      {addon.selected ? "Added" : "Add"}
    </Button>
  );
};

export default QuoteButtonAdd;

interface Props {
  className?: string;
  addon: QuoteLineItem;
  onAddAddon: (addon: QuoteLineItem) => void;
  disabled?: boolean;
  [x: string]: any;
}

const useStyles = makeStyles(() => ({
  buttonAdded: {
    backgroundColor: colors.white,
    border: "1px dashed black",
    fontWeight: "bold",
    color: colors.darkGrey,
    width: "130px"
  },
  button: {
    fontWeight: "bold",
    width: "130px"
  },
  icon: {
    verticalAlign: "sub"
  }
}));
